import { render } from "./kiosk-activity-logs.vue?vue&type=template&id=1542b6d5"
import script from "./kiosk-activity-logs.vue?vue&type=script&lang=js"
export * from "./kiosk-activity-logs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__